import { TypeId } from 'src_common/common/websocket2/type';
import { EventMarketsItemState } from 'src/domains/sportsbook/trading/view/eventDetails/markets/eventMarketsItem/EventMarketsItem.state';
import { observer } from 'src/utils/mobx-react';
// eslint-disable-next-line no-restricted-imports
import { useAsObservableSource } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import React, { useState } from 'react';
import Link from 'src/components/Link/Link';
import styled from '@emotion/styled';
import { RowMarketItemState } from 'src/domains/sportsbook/trading/view/eventDetails/markets/eventMarketsItem/RowMarketItem.state';
import { MarketId } from 'src_common/common/websocket2/id/WebsocketId';

const RowTemporaryItem = styled('div', { label: 'RowTemporaryItem' })`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export type RowMarketItemPropsType = {
    marketId: MarketId;
    inner?: boolean;
    toggle: (shortName: string, marketId: number) => void;
    shortname: string;
    eventMarketsItemState: EventMarketsItemState;
};

export const RowMarketItem = observer('RowMarketItem', (propsIn: RowMarketItemPropsType) => {
    const props = useAsObservableSource(propsIn);
    const appState = useAppStateContext();
    const [state] = useState(() => new RowMarketItemState(appState, props));

    const marketModel = props.marketId.getModel();

    if (marketModel === null) {
        return null;
    }

    const wrapperClassName =
        props.eventMarketsItemState.isGroupExpended || props.eventMarketsItemState.marketExpanded !== undefined
            ? 'event-markets-table-row__opened'
            : '';
    const eventId = props.marketId.getEventId().toOldId();
    const sortOrder = appState.routerBackoffice.getParameter('events', 'sortOrder');
    return (
        <RowTemporaryItem className={wrapperClassName}>
            <div className='cell first'>
                <Link
                    route={`events:${eventId}`}
                    parameters={{
                        tab: 'markets',
                        market: TypeId.getMarketId(marketModel.id),
                        filterMarket: props.eventMarketsItemState.filter,
                        ...(sortOrder !== null && { sortOrder }),
                    }}
                    onClick={state.onMarketNameClickHandler}
                    dataTest={`market-name-${marketModel.name}`}
                >
                    {state.marketName}
                </Link>
            </div>
            <div className='cell other'>
                {props.inner === true && marketModel.line !== null ? (
                    <span className='event-markets-badge'>{marketModel.line}</span>
                ) : undefined}
            </div>
            <div className='event-markets-table-column__state cell other'>{state.getMarketState}</div>
            <div className='cell other'>{marketModel.sp ? 'SP' : undefined}</div>

            <div className='cell other'>
                {state.markets.length > 1 ? (
                    <span className='event-markets-badge'>{state.markets.length} markets</span>
                ) : undefined}
            </div>
            <div className='cell other'>
                <div className='element checkbox'>
                    <label>
                        <input
                            type='checkbox'
                            name='active'
                            checked={
                                state.markets.length > 1
                                    ? props.eventMarketsItemState.isGroupActive
                                    : marketModel.active
                            }
                            onChange={state.onClickActiveHandler}
                        />
                        <span>Active</span>
                    </label>
                </div>
            </div>
            <div className='cell other'>
                <div className='element checkbox'>
                    <label>
                        <input
                            type='checkbox'
                            name='display'
                            checked={
                                state.markets.length > 1
                                    ? props.eventMarketsItemState.isGroupDisplay
                                    : marketModel.display
                            }
                            onChange={state.onClickDisplayHandler}
                        />
                        <span>Display</span>
                    </label>
                </div>
            </div>
            <div className='cell other nowrap'>
                {state.markets.length === 1 ? (
                    <div>
                        <Link
                            route='global:trading'
                            onClick={state.onClickSingleLiabilities}
                            className='event-markets-liabilities-badge green'
                            parameters={{ tab: 'liabilities' }}
                        >
                            Single liabs
                        </Link>
                        <Link
                            route='global:trading'
                            onClick={state.onClickMultipleLiabilities}
                            className='event-markets-liabilities-badge green'
                            parameters={{ tab: 'liabilities' }}
                        >
                            Multi liabs
                        </Link>
                    </div>
                ) : undefined}
            </div>
            <div className='cell other'>
                {state.markets.length === 1 ? (
                    <button
                        className='auditLink'
                        onClick={state.onAuditLinkHandler}
                    >
                        Audit
                    </button>
                ) : undefined}
            </div>
            <div
                className='cell dragger'
                data-movable-handle
            >
                <span className={props.inner === true ? 'event-markets__inner-dragger' : 'event-markets__dragger'}>
                    <span>&middot;</span>
                    <span>&middot;</span>
                </span>
            </div>
        </RowTemporaryItem>
    );
});
